export const FETCHING_INVOICE = "@invoice/fetchingInvoice";
export const FETCHING_INVOICE_ERROR = "@invoice/fetchingInvoiceError";
export const FETCHING_INVOICE_SUCCESS = "@invoice/fetchingInvoiceSuccess";
export const FETCHING_INVOICE_CANCEL = "@invoice/fetchingInvoiceCancel";

export const DEACTIVATE_STATEMENT = "@invoice/deactivateStatement";
export const DEACTIVATE_STATEMENT_ERROR = "@invoice/deactivateStatementError";
export const DEACTIVATE_STATEMENT_SUCCESS = "@invoice/deactivateStatementSuccess";

export const DOWNLOAD_INVOICE = "@invoice/downloadInvoice";
export const DOWNLOAD_INVOICE_ERROR = "@invoice/downloadInvoiceError";
export const DOWNLOAD_INVOICE_SUCCESS = "@invoice/downloadInvoiceSuccess";

export const GO_TO_PAYMENT_GATEWAY = "@invoice/goToPaymentGateway";
export const GO_TO_PAYMENT_GATEWAY_ERROR = "@invoice/goToPaymentGatewayError";
export const GO_TO_PAYMENT_GATEWAY_SUCCESS = "@invoice/goToPaymentGatewaySuccess";

export const PRINT_PAYMENT = "@invoice/printPayment";
export const PRINT_PAYMENT_ERROR = "@invoice/printPaymentError";
export const PRINT_PAYMENT_SUCCESS = "@invoice/printPaymentSuccess";

export const CLEAR_STORE = "@invoice/clearStore";
export const DELETE_INVOICE_AGENT = "@invoice/deleteInvoiceAgent";

export const REFRESH_WEBHOOK_ERROR = "@invoice/refreshWebHookError";
export const REFRESH_WEBHOOK_SUCCESS = "@invoice/refreshWebHookSuccess";
export const REFRESH_WEBHOOK = "@invoice/refreshWebHook";

export const CHECK_WEBHOOK_STATUS_ERROR = "@invoice/checkWebhookStatusError";
export const CHECK_WEBHOOK_STATUS_SUCCESS = "@invoice/checkWebhookStatusSuccess";
export const CHECK_WEBHOOK_STATUS = "@invoice/checkWebhookStatus";

export const CHECK_VOID_AVAILABLE = "@invoice/checkVoidAvailable";
export const CHECK_VOID_AVAILABLE_SUCCESS = "@invoice/checkVoidAvailableSuccess";

export const VOID_INVOICE = "@invoice/voidInvoice";
export const VOID_INVOICE_STATUS = "@invoice/voidInvoiceStatus";

export const CHANGE_INVOICE_STATUS = "@invoice/changeInvoiceStatus";
export const CHANGE_INVOICE_STATUS_ERROR = "@invoice/changeInvoiceStatusError";
export const CHANGE_INVOICE_STATUS_SUCCESS = "@invoice/changeInvoiceStatusSuccess";
